import "./src/styles/global.css";
import React from "react";
import type { GatsbyBrowser } from "gatsby";
import "./sentry.config";
import ScrollTopTop from "./src/components/ScrollToTop";
import FloatingCallButton from "./src/components/FloatingButton";
import { persistAttributionFromLocation } from "@/lib/utils";
import { createSiteProposalCapture } from "@/lib/siteProposalCapture";

let proposalCapture: ReturnType<typeof createSiteProposalCapture> | undefined;

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  return (
    <>
      <FloatingCallButton />
      <ScrollTopTop />
      {element}
    </>
  );
};

export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  proposalCapture?.stop();
  proposalCapture = createSiteProposalCapture(
    process.env.GATSBY_RUNTIME_ENV, process.env.GATSBY_PROPOSAL_CAPTURE_ENDPOINT,
  );
  proposalCapture.navigate(window.location.href);

  function onError(e: ErrorEvent) {
    try {
      const msg = (e && (e.message || (e.error && e.error.message))) || "";
      const stack = (e && e.error && e.error.stack) || "";
      if (
        msg.includes("Cannot read properties of null") &&
        stack.includes("mini-css-extract-plugin")
      ) {
        e.preventDefault?.();
      }
    } catch (err) {
      // ignore
    }
  }

  function onRejection(ev: PromiseRejectionEvent) {
    try {
      const reason = ev && ev.reason;
      const msg = (reason && (reason.message || reason.toString())) || "";
      const stack = (reason && reason.stack) || "";
      if (
        msg.includes("Cannot read properties of null") &&
        stack &&
        stack.includes("mini-css-extract-plugin")
      ) {
        ev.preventDefault?.();
      }
    } catch (err) {
      // ignore
    }
  }

  window.addEventListener("error", onError as EventListener);
  window.addEventListener("unhandledrejection", onRejection as EventListener);

  persistAttributionFromLocation(window.location);
};

export const onPreRouteUpdate: GatsbyBrowser["onPreRouteUpdate"] = ({ location }) => {
  proposalCapture?.navigate(location.href);
  persistAttributionFromLocation(location);
};
